export const aboutRoutes = (root: string) => ({
  root,
});
